const TAMANHO_CNPJ_SEM_DV = 12;
const REGEX_CARACTERES_FORMATACAO = /[./-]/g;
const REGEX_FORMACAO_COM_DV = /^[A-Z\d]{12}\d{2}$/;
const REGEX_VALOR_ZERADO = /^0+$/;
const VALOR_BASE = '0'.charCodeAt(0);
const PESOS_DV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

class Cnpj {
  isValid(cnpj) {
    if (cnpj == null) return false;

    cnpj = this._removeCaracteresFormatacao(cnpj);

    if (!this._isFormacaoValidaComDV(cnpj)) return false;

    const dvInformado = cnpj.substring(TAMANHO_CNPJ_SEM_DV);
    const dvCalculado = this._calculaDV(cnpj.substring(0, TAMANHO_CNPJ_SEM_DV));

    return dvCalculado === dvInformado;
  }

  _calculaDV(baseCnpj) {
    const dv1 = String(this._calculaDigito(baseCnpj));
    const dv2 = String(this._calculaDigito(baseCnpj + dv1));
    return dv1 + dv2;
  }

  _calculaDigito(cnpj) {
    let soma = 0;
    for (let indice = cnpj.length - 1; indice >= 0; indice--) {
      const valorCaracter = cnpj.charCodeAt(indice) - VALOR_BASE;
      soma += valorCaracter * PESOS_DV[PESOS_DV.length - cnpj.length + indice];
    }
    return soma % 11 < 2 ? 0 : 11 - (soma % 11);
  }

  _removeCaracteresFormatacao(cnpj) {
    return cnpj.trim().replace(REGEX_CARACTERES_FORMATACAO, '');
  }

  _isFormacaoValidaComDV(cnpj) {
    return REGEX_FORMACAO_COM_DV.test(cnpj) && !REGEX_VALOR_ZERADO.test(cnpj);
  }
}

export default new Cnpj();
